import { HStack } from '@montel/montelpro-shared-components-v2';
import { FilterGroup, FilterButton } from './ColumnFilters.styles';

import { Counter } from './Counter';
import { useTableContext } from './TableContextProvider';
import { styled } from 'styled-components';

const HStackWithoutLineBreak = styled(HStack)`
	white-space: nowrap;
`;

export function ColumnFilters<T>() {
	const { filterState, toggleFilter } = useTableContext<T>();

	return (
		<HStack gap={filterState?.treatGroupsAsSingle ? 'xs' : 'xl'}>
			{filterState?.groups.map((filterGroup, index) => (
				<FilterGroup key={`${filterGroup.columnId}_${index}`}>
					{filterGroup.filters?.map((filter, index) => (
						<FilterButton
							$checked={Boolean(filter.selected)}
							$groupCanBeCleared={filterGroup.groupCanBeCleared}
							key={`${filter.id}_${index}`}
							onClick={() => toggleFilter(filter)}
						>
							<HStackWithoutLineBreak
								align="center"
								justify="center"
							>
								{filter.text}
								{typeof filter.count !== 'undefined' &&
									filter.count > 0 && (
										<Counter count={filter.count} />
									)}
							</HStackWithoutLineBreak>
						</FilterButton>
					))}
				</FilterGroup>
			))}
		</HStack>
	);
}
